module.exports = __webpack_public_path__ + "e16.no2.47dae206.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/e16.no2.jpg
// module id = ELXr
// module chunks = 0